import './App.css';
import './index.css'
import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
/**
 * Archivos generales de utilidades y configuración de la app
 */
import { ProtectedRoute } from './app/router/ProtectedRoute';
import { PublicRoute } from './app/router/PublicRoute';
import { DashboardLayout } from './app/components/layout/DashboardLayout/DashboardLayout';

/**
 * Rutas de acceso publico para cualquier usuario sin autenticación
 */
import { RegistrationPage } from './app/pages/public/RegistrationPage/RegistrationPage';
import { SuccessPage } from './app/pages/public/SuccessPage/SuccessPage';
import { SearchLinkPage } from './app/pages/public/SearchLinkpage/SearchLinkPage';
import { SearchMyNetworkPage } from './app/pages/public/SearchMyNetworkPage/SearchMyNetworkPage';
import { LoginPage } from './app/pages/public/LoginPage/LoginPage';
import { WhatsappLinksPage } from './app/pages/public/WhatsappLinkPage/WhatsappLinksPage';
import { ForgotPasswordPage } from './app/pages/public/ForgotPasswordPage/ForgotPasswordPage';

/**
 * rutas de acceso privado para el dashboard, requieren estar logueados
 */
import { UserPage } from './app/pages/private/UserPage/UserPage';
import { ManageLinksWhatsapp } from './app/pages/private/ManageLinksWhatsapp/ManageLinksWhatsapp';
import { PolicyDataPage } from './app/pages/public/PolicyDataPage/PolicyDataPage';

function App() {
  useEffect(() => {
    const themeColor = process.env.REACT_APP_THEME_COLOR_PRIMARY;
    const themeSecondaryColor = process.env.REACT_APP_THEME_COLOR_SECONDARY;
    const themeTertiaryColor = process.env.REACT_APP_THEME_COLOR_TERTIARY;
    const themeQuaternaryColor = process.env.REACT_APP_THEME_COLOR_QUATERNARY;
    const themeFont = process.env.REACT_APP_THEME_FONT;
    const layout = process.env.REACT_APP_LAYOUT || 'classic';
    
    if (themeColor) {
      document.documentElement.style.setProperty('--color-primary', themeColor);
    }
    if (themeSecondaryColor) {
      document.documentElement.style.setProperty('--color-secondary', themeSecondaryColor);
    }
    if (themeTertiaryColor) {
      document.documentElement.style.setProperty('--color-tertiary', themeTertiaryColor);
    }
    if (themeQuaternaryColor) {
      document.documentElement.style.setProperty('--color-quaternary', themeQuaternaryColor);
    }
    if (themeFont) {
      document.documentElement.style.setProperty('--font-primary', themeFont);
    }

    // Apply layout class to body
    document.body.classList.add(layout);

    return () => {
      document.body.classList.remove(layout);
    };
  }, []);

  return (
    <Routes>
      {/* Ruta principal para el registro */}
      <Route path="/" element={<RegistrationPage />} />
      <Route path="/register" element={<RegistrationPage />} />

      {/* Ruta para mostrar después de un registro exitoso */}
      <Route path="/success/:userId" element={<SuccessPage />} />
      
      {/* Ruta para recuperar un link ya generado */}
      <Route path="/recoverlink" element={<SearchLinkPage />} />

      {/* Ruta para obtener la red */}
      <Route path="/searchmynetwork" element={<SearchMyNetworkPage />} />

      {/* Ruta para ver los grupos de WhatsApp */}
      <Route path="/whatsapp-groups" element={<WhatsappLinksPage />} />

       {/* Ruta para politica de datos */}
      <Route path="/policy-data" element={<PolicyDataPage />} />

      {/* Rutas Públicas: Si el usuario está logueado, redirige a /dashboard */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      </Route>

      {/* Rutas Protegidas: Solo usuarios autenticados pueden acceder */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<DashboardLayout><UserPage /></DashboardLayout>} />
        <Route path="/manage-whatsapp" element={<DashboardLayout><ManageLinksWhatsapp /></DashboardLayout>} />
      </Route>
    </Routes>
  );
}

export default App;
